import React from 'react';
import './add deal.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message } from "antd";
import { UploadOutlined } from '@ant-design/icons';


class AddDeal extends React.Component {
    state = {
        client:'',
        advertisement:'',
        contractFile: null,
        contractFileType:'data',
        recieptFile: null,
        recieptFileType:'data',
        
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    add = () => {
        const {client,advertisement,contractFile,recieptFile,recieptFileType} = this.state
            if(hasValue(client)&&hasValue(advertisement) && contractFile !=null){
                let l = message.loading('Wait..', 2.5)
                let data = new FormData()
                data.append('client',client)
                data.append('advertisement',advertisement)
                data.append('contractFile',contractFile)
                if(this.state.recieptFile !== null && this.state.recieptFileType === "data"){
                    data.append('contractFileType',this.state.recieptFileType)
                }
                console.log(Array.from(data))
                axios.post(`${BASE_END_POINT}deals`,data,{
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization':`Bearer ${this.props.currentUser.token}`,
                    'Accept-Language':this.props.isRTL?'ar':'en'
                    },
                })
                .then(response=>{
                console.log("deal added  ",response.data)
                l.then(() => message.success(allStrings.done, 2.5) )
                    this.props.history.goBack() 
                })
                .catch(error=>{
                    console.log(error.response)
                    l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
                })
        }
    }

   

    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.add()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    fileChangedHandler = event => {
      this.setState({
        contractFile: event.target.files[0],
        contractFileType:"data"
      })
    }
    removeFile = () => {
      this.setState({
          contractFile:null,
          contractFileType:"url"
      });
    }
    fileChangedHandler2 = event => {
      this.setState({
        recieptFile: event.target.files[0],
        recieptFileType:"data"
      })
    }
    removeFile2 = () => {
      this.setState({
          recieptFile:null,
          recieptFileType:"url"
      });
    }
  render(){
    console.log("type",this.state.type)
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('DEALS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div  style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background: 'linear-gradient(135deg, #1D9598, #127275)'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>content_paste</span>
                            </div>
                            <div className="tableTitle" style={{display:'inline-block',marginTop:'-60px',
                            marginLeft:'0',marginRight:'0'}}>
                            <p>{allStrings.addDeal}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.client}</label>
                                            <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.client} type="text" id="form645" name="client" className="form-control" onChange={this.changeHandler} required  validate placeholder="أدخل البيانات..."/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.adveristment}</label>
                                            <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.advertisement} type="text" id="form56" name="advertisement" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل البيانات..."/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <label for="form830" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.recieptFile}</label>
                                            <div className="fileUpload2"> 
                                                <input  key={this.state.recieptFile} type='file' className="upImgs2" onChange={this.fileChangedHandler2} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.uploadFile}</span></span>
                                            </div>
                                            {this.state.recieptFile&&
                                            <div className="preview">
                                                <div style={{ display: "inline-block" }}>
                                                    <p className="previewPdf">{this.state.recieptFile.name}
                                                        <MDBIcon icon="times" className="mr-2 removePdf"
                                                        onClick={() => this.removeFile2()}  ></MDBIcon>
                                                    </p>
                                                </div>
                                            </div>
                                            }
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <label for="form830" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.contractFile}</label>
                                            <div className="fileUpload2"> 
                                                <input  key={this.state.contractFile} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.uploadFile}</span></span>
                                            </div>
                                            {this.state.contractFile&&
                                            <div className="preview">
                                                <div style={{ display: "inline-block" }}>
                                                    <p className="previewPdf">{this.state.contractFile.name}
                                                        <MDBIcon icon="times" className="mr-2 removePdf"
                                                        onClick={() => this.removeFile()}  ></MDBIcon>
                                                    </p>
                                                </div>
                                            </div>
                                            }
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                        <MDBBtn
                                        style={{background:'linear-gradient(135deg, #1D9598, #127275)',color:'#fff'}}
                                        rounded
                                        color="#1D9598"
                                        type="submit"
                                        className="btn-block z-depth-1a"
                                        >
                                        <MDBIcon icon="plus" className="mr-2" />
                                            {allStrings.add}          
                                        </MDBBtn>
                                       
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddDeal)
  );